function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeartFilled = function SvgHeartFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m11 8 7.071-6.317a5.866 5.866 0 0 1 8.225 0 5.7 5.7 0 0 1 0 8.127L13.959 22 1.7 9.81a5.7 5.7 0 0 1 0-8.127 5.866 5.866 0 0 1 8.225 0S14.582 5.533 17 8",
    style: {
      fill: "currentColor",
      stroke: "currentColor",
      strokeLinecap: "square",
      strokeMiterlimit: 10,
      strokeWidth: 2
    },
    transform: "translate(2 5)"
  }));
};
export default SvgHeartFilled;